export interface HighlightChunk {
  start: number
  end: number
  highlight: boolean
}

const REGEX_SPECIAL_CHARS = /[-[\]/{}()*+?.\\^$|]/g

/**
 * Splits `text` into chunks that do and do not match `search`
 * (case-insensitive, matched literally). An empty `search` yields one
 * non-highlighted chunk covering the whole text.
 */
export const findHighlightChunks = (
  text: string | undefined,
  search: string | undefined,
): HighlightChunk[] => {
  if (!text) return []
  if (!search) return [{ start: 0, end: text.length, highlight: false }]

  const pattern = new RegExp(search.replace(REGEX_SPECIAL_CHARS, '\\$&'), 'gi')
  const chunks: HighlightChunk[] = []
  let lastEnd = 0
  for (const match of text.matchAll(pattern)) {
    const start = match.index
    const end = start + match[0].length
    if (start > lastEnd) {
      chunks.push({ start: lastEnd, end: start, highlight: false })
    }
    chunks.push({ start, end, highlight: true })
    lastEnd = end
  }
  if (lastEnd < text.length) {
    chunks.push({ start: lastEnd, end: text.length, highlight: false })
  }
  return chunks
}
